import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {buildVersion} from 'utils/buildVersion';
import {planStatusSnackbarActionFactory} from './usePlanOptimization';
import {useSnackbar} from 'notistack';
import {useAsync} from './useAsync';

const URL: string = '/version.json';
const OPTIONS: object = {cache: 'no-store'};

export const useRefreshApplication = () => {
  const {data} = useAsync(fetchLatestVersion);

  const {t} = useTranslation('common');
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();

  data?.version && logVersion(data?.version);

  const openToast = () => {
    enqueueSnackbar(t('aNewVersionIsAvailableFE'), {
      persist: true,
      action: planStatusSnackbarActionFactory({
        onClick: () => {
          closeSnackbar();
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          window.location.reload(true);
        },
        text: t('reload'),
        closeSnackbar,
        dismissText: t('dismiss'),
      }),
      variant: 'info',
    });
  };

  useEffect(() => {
    if (data?.version && data.version !== buildVersion) {
      openToast();
    }
  }, [data?.version]);
};

const fetchLatestVersion = async (): Promise<IVersion> =>
  await fetch(URL, OPTIONS).then(async (response) => await response.json());

const logVersion = (version: string): void => {
  console.log('\x1B[90;92;1mBioplan™ \x1B[90;92;2mfrontend version ' + version);
};

interface IVersion {
  version: string;
}
